import {
    type FlexStyle,
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    ResizablePanelGroupDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import type {
    ResizableOrientation
} from "../../type";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";

export const RESIZABLE_FLEX_DIRECTIONS: Record<ResizableOrientation, FlexStyle["flexDirection"]> = {
    horizontal: "row",
    vertical: "column"
};

const stylesheet = StyleSheet.create({
    root: {
        height: "100%",
        width: "100%"
    },
    inner: {
        flexShrink: 1,
        flexGrow: 1
    },
    rootAuto: {
        width: "100%"
    }
});

export const useStyles = ({
    shapeConfigs,
    orientation,
    isFramed,
    radiuses,
    borders,
    colors,
    spaces,
    mode
}: ResizablePanelGroupDynamicStyleType) => {
    const styles = {
        inner: {
            flexDirection: RESIZABLE_FLEX_DIRECTIONS[mode === "split" ? orientation : "vertical"]
        } as Mutable<ViewStyle>,
        root: {} as Mutable<ViewStyle>
    };

    if(isFramed) {
        Object.assign(styles.root, {
            backgroundColor: colors.content.container.raised,
            borderColor: colors.content.border.subtle,
            borderWidth: borders.line,
            overflow: "hidden"
        }, getCornerStyle({
            radius: radiuses.surface,
            shapeConfigs
        }));
    }

    if(mode === "tabs") {
        Object.assign(styles.root, {
            paddingHorizontal: spaces.spacingMd,
            paddingTop: spaces.spacingMd,
            gap: spaces.spacingMd
        });
    }

    return styles;
};
export default stylesheet;
